const State = {
  partner: {},
  qrCode: [],
  withKeyBoard: [],
  partnerMovingBoxes: undefined
};
export default State;
